import { EUnreadMessagesCountActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 *  Установить количество непрочитанных сообщений
 */
export const setUnreadMessagesCount = actionGenerator<EUnreadMessagesCountActionTypes.Set, number>(
  EUnreadMessagesCountActionTypes.Set,
);
